import { Image, TextSeo, ViewSeo } from "@ctv/shared-core/src";
import { FeatureContent } from "../types";
import cssStyles from "./FeatureItem.module.css";

type Props = {
  imageAlt?: string;
  imageUrl: string;
  title: string;
  contents: FeatureContent[];
  reverse?: boolean;
};

export default function FeatureItem(props: Props) {
  const { imageAlt = "", imageUrl, title, contents, reverse = false } = props;
  return (
    <ViewSeo spacing="xxxxxl" row className={reverse ? cssStyles.reverse : ""}>
      <Image alt={imageAlt} src={imageUrl} width={300} height={300} />
      <ViewSeo className={cssStyles.contentGroup} spacing="l">
        <TextSeo variant="display">{title}</TextSeo>
        {contents.map((content) => (
          <ViewSeo spacing="xxs" key={content.title}>
            <TextSeo variant="ui-large" ink="black-primary">
              {content.title}
            </TextSeo>
            <TextSeo variant="ui-baseline" ink="black-secondary">
              {content.content}
            </TextSeo>
          </ViewSeo>
        ))}
      </ViewSeo>
    </ViewSeo>
  );
}
